<template>
  <div id="mall-iframe">
    <api-loading :show="loading"></api-loading>
    <div
      v-if="mallUrl != ''"
      class="br-contentpanel"
      :data-min="leftSideStatus"
    >
      <iframe
        :src="mallUrl + '&fromIndex=1'"
        :style="{ height: ifmHeight + 'px' }"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftSideStatus: true, //左边栏状态
      ifmHeight: $(window).height() - $(".br-header").height() - 8,
      mallUrl: "",
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    $.api_call("api.User.getProductSaleUrl", {}, (r) => {
      if (r.ErrorCode == "9999") {
        this.mallUrl = r.Data.Results;
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      } else {
        this.loading = false;
        if (r.ErrorCode == "1002") {
          userFailure(this);
        } else {
          ShowTip(r.Message, "danger");
        }
      }
    });
    $(".side-btn-group").hide();
    $(window).resize(() => {
      this.ifmHeight = $(window).height() - $(".br-header").height() - 8;
    });
  },
  beforeDestroy() {
    $(".side-btn-group").show();
  },
};
</script>

<style lang="less">
iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>